import { useContext } from 'react';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import { TwoFactorRecoveryContext } from '../../contexts/twoFactorRecovery';
import { P } from './TwoFactorStyledComponents';
import { TwoFactorRecoveryAlerts } from './TwoFactorRecoveryAlerts';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TwoFactorRecoverySupport = () => {
  const {
    email,
    isRecovering,
    onClickSupportRecovery,
    recoveryAttempted,
    recoverySent
  } = useContext(TwoFactorRecoveryContext);
  return /*#__PURE__*/_jsxs(UIDialogBody, {
    children: [/*#__PURE__*/_jsx(P, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reAuth.recovery.recoverySupport.form.description"
      })
    }), /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "reAuth.recovery.recoverySupport.form.descriptionMore",
        options: {
          email
        }
      })
    }), /*#__PURE__*/_jsx(TwoFactorRecoveryAlerts, {}), /*#__PURE__*/_jsx(UILoadingButton, {
      "data-test-id": "support-recovery-initiate-button",
      disabled: !isRecovering && recoveryAttempted,
      loading: isRecovering,
      onClick: onClickSupportRecovery,
      resultIcon: !recoveryAttempted || recoverySent ? 'success' : 'remove',
      type: "submit",
      use: "primary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reAuth.recovery.recoverySupport.form.recoverButton"
      })
    })]
  });
};